import {debounce} from 'lodash';

import { i18n } from "@/locales/i18n";
import store from "@/store"
import GrmAlert from "@/components/Common/alert/GrmAlert"
import GrmCamstudyAlert from '@/components/Common/camstudyAlert/CamstudyAlert.vue'
import ToastMessage from "@/components/Common/toastMessage/ToastMessage.vue";

export default {
    install(Vue) {
        Object.assign(Vue.prototype, {
            $alert: function(options, callback) {
                const $vue = this
                const $alert = {
                    data: {
                        fade: true,
                        callback
                    },
                    init() {
                        if (typeof options === 'string') {
                            options = {
                                text: options,
                                onlyOk: true,
                            }
                        }
                        this.show()
                    },
                    show() {
                        const div = document.createElement('div')
                        const app = document.querySelector('#app')
                        app.appendChild(div)
                        new Vue({
                            data: this.data,
                            store,
                            i18n,
                            render: h => h(GrmAlert, { props: options }),
                        }).$mount(div)
                    },
                }
                $alert.init()
            },
            $camsAlert: function(options, callback) {
                const $vue = this
                const $alert = {
                    data: {
                        callback
                    },
                    init() {
                        if (typeof options === 'string') {
                            options = {
                                text: options,
                                onlyOk: true,
                            }
                        }
                        this.show()
                    },
                    show() {
                        const div = document.createElement('div')
                        const app = document.querySelector('#app')
                        app.appendChild(div)
                        new Vue({
                            data: this.data,
                            store,
                            i18n,
                            render: h => h(GrmCamstudyAlert, { props: options }),
                        }).$mount(div)
                    },
                }
                $alert.init()
            },
            $toastMessage: function(options, callback) {
                const $vue = this
                const $alert = {
                    data: {
                        fadeOpacity: true,
                        callback
                    },
                    init() {
                        if (typeof options === 'string') {
                            options = {
                                text: options,
                                onlyOk: true,
                            }
                        }
                        this.show()
                    },
                    show() {
                        const div = document.createElement('div')
                        const app = document.querySelector('#app')
                        app.appendChild(div)
                        new Vue({
                            data: this.data,
                            store,
                            i18n,
                            render: h => h(ToastMessage, { props: options }),
                        }).$mount(div)
                    },
                }
                $alert.init()
            },
            $confirm: function(options, callback) {
                if(typeof options === 'string'){
                    options = {
                        text: options
                    }
                }
                options.onlyOk = false;
                this.$alert(options, callback);
            }
        })

        Vue.prototype.$setCookie = function(name, value, days) {
            let expires;
            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = `; expires=${date.toGMTString()}`;
            } else {
                expires = "";
            }
            document.cookie = `${name}=${value}${expires}; path=/`;
        }

        Vue.prototype.$getCookie = function(name) {
            const nameOfCookie = name + "=" ;
            let a = 0;
            let endOfCookie
            while (a <= document.cookie.length) {
                const b = (a + nameOfCookie.length);
                if (document.cookie.substring(a,b) === nameOfCookie) {
                    if ((endOfCookie=document.cookie.indexOf(";",b)) === -1) {
                        endOfCookie=document.cookie.length;
                    }
                    return unescape(document.cookie.substring(b,endOfCookie));
                }
                a = document.cookie.indexOf(" ",a) + 1;
                if (a === 0) {
                    break;
                }
            }
            return "";
        }

        Vue.prototype.$CookieUtils = {
            getRootDomain: function(){
                let str =location.host.substring(0, location.host.lastIndexOf('.'));
                let idx = str.lastIndexOf('.');
                let domain = location.host.substring(idx+1);
                if(location.port){
                    domain = domain.substring(0, domain.indexOf(':'));
                }
                return domain;
            },
            set: function(name, value, options={}){
                let {expiresSeconds, domain, path} = options;
                if(expiresSeconds === undefined){
                    expiresSeconds = 60*60*24;
                }

                let expires = new Date(Date.now() + (expiresSeconds*1000)).toUTCString();
                domain = domain
                || options.rootDomain ? this.getRootDomain() : location.host;
                let cookie = `${name?name:''}=${value};`
                    + `expires=${expires};`
                    + `path=${path||'/'};`
                    + `domain=${domain};`;
                document.cookie = cookie;
                return cookie;
            },
            value: function(name){
                return this.values(name, 1);
            },
            values: function(name, limit){
                if(!document.cookie){
                    return;
                }

                const arr = document.cookie.split(';');
                let values;
                for(let i=arr.length-1; i>=0; i--){
                    let cookie = arr[i].trim();
                    if(!cookie.startsWith(name + '=')){
                        continue;
                    }
                    const v = cookie.substring(name.length + 1).trim();
                    if(limit === 1){
                        return v;
                    }
                    if(!values) values = [];
                    values.push(v);
                }
                return values;
            },
            remove: function(name, options={}){
                let {domain} = options;
                let domains;
                if(domain){
                    domains = [domain];
                }else{
                    let rootDomain = this.getRootDomain();
                    domains = [rootDomain];
                    if(rootDomain != location.host){
                        domains.push(location.host);
                    }
                }

                const opt = {
                    ...options,
                    ... {
                        expiresSeconds: 0,
                    }
                };
                domains.forEach(domain => {
                    // console.log('@@@', opt, domain)
                    this.set(name, '', {...opt, ...{domain}});
                });
            }
        }

        const modalList = []
        const modalTimeout = {}
        let modalTimeoutMs = 300
        Vue.prototype.$modal = function(component, options = {
            data: {},
            exist: false,
            once: false,
            close: false,
        }, callback = () => {}) {
            if (typeof component === 'string') {
                component = {
                    name: component,
                }
            }

            if (modalTimeout[component.name]) {
                return;
            }

            modalTimeout[component.name] = setTimeout(() => {
                modalTimeout[component.name] = null
            }, modalTimeoutMs)

            const idx = modalList.findIndex(m => m.instance.$children[0].$options.name === component.name)

            const onceList = modalList.filter(m => m.options.once);
            onceList.forEach((once) => {
                const onceIdx = modalList.findIndex(m => m.instance.$children[0].$options.name === once.instance.$children[0].$options.name)
                if(onceIdx === idx){
                    return
                }
                const exist = modalList[onceIdx].options.exist
                if (exist) {
                    const $el = modalList[onceIdx].instance.$el
                    if(!$el.classList.contains('fadeOut')) {
                        $el.classList.add('fadeOut')
                    }
                    return
                }
                modalList[onceIdx].instance.destroy({...modalList[onceIdx].options.data})
                modalList.splice(onceIdx, 1)
            })

            if (idx > -1) {
                const exist = modalList[idx].options.exist
                const $el = modalList[idx].instance.$el
                if (exist) {
                    const isShow = !$el.classList.contains('fadeOut') && modalList[idx].instance.$el.style.display === 'block'

                    modalList[idx].instance.$el.style.display = 'block'
                    const comp = modalList[idx].instance.$children[0];
                    if (isShow) {
                        $el.classList.add('fadeOut')
                        try{
                            comp?.onHideModal?.();
                        }catch(e){
                            console.error(e);
                        }
                    } else {
                        $el.classList.remove('fadeOut')
                        try{
                            comp?.onShowModal?.();
                        }catch(e){
                            console.error(e);
                        }
                    }
                    callback()
                    return
                }
                modalList[idx].instance.destroy({...modalList[idx].options.data})
                modalList.splice(idx, 1)
                callback()
                return
            }

            const $vue = this
            const $modal = {
                data: {
                    ...options.data,
                    fade: options.data?.fade === undefined ? true : options.data.fade,
                },
                init() {
                    this.show()
                },
                show() {
                    const div = document.createElement('div')
                    $vue.$root.$el.appendChild(div)
                    const instance = new Vue({
                        data: this.data,
                        store,
                        i18n,
                        render: h => h(component),
                    }).$mount(div)

                    if (options.exist) {
                        instance.$el.style.display = 'none'
                    }

                    if (idx < 0) {
                        modalList.push({ instance, options })
                    }
                    callback()
                },
            }
            $modal.init()
        }

        Vue.prototype.$isModalShown = function(componentName, options = {}) {
            const idx = modalList.findIndex(m => m.instance.$children[0].$options.name === componentName)
            if (idx > -1) {
                const $el = modalList[idx].instance.$el
                return !$el.classList.contains('fadeOut') && $el.style.display === 'flex'
            }
            return false
        }
        Vue.prototype.$isOpenedModal = function(componentName, options = {}) {
            const idx = modalList.findIndex(m => m.instance.$children[0].$options.name === componentName)
            if (idx > -1) {
                if(!modalList[idx].instance.$el.style){
                    return false;
                }
                if(modalList[idx].instance.$el.style.display === 'none') {
                    return false;
                }
                return !(modalList[idx].options.exist && modalList[idx].instance.$el.classList.contains('fadeOut'));
            }
            return false
        }

        Vue.mixin({
            mounted() {
                if (this.fade && this.$el.classList) {
                    this.$el.classList.add('fadeIn')
                }
                if(this.fadeOpacity){
                    this.$el.classList.add('fadeOpacity')
                }
            },
            methods: {
                destroy(options) {
                    if(options.fade === undefined){
                        options.fade = true;
                    }
                    const destroy = () => {
                        setTimeout(() => {
                            this.$el.remove()
                            this.$destroy()
                        }, 200)
                    }
                    if (options.fade && this.$el.classList) {
                        this.$el.classList.add('fadeOut')
                        destroy()
                        return
                    }
                    if(options.fadeOpacity){
                        this.$el.classList.remove('fadeOpacity')
                        this.$el.classList.add('fadeOpacityOut')
                        destroy()
                        return;
                    }
                    destroy()
                }
            }
        })
    }
}